import {post} from 'axios'
import {
    GET_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
    LOAD_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
    ERROR_COUNT_LOADING_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
    EMPTY_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY} from './Types';


export const getCountForSubscriptionByCountry =(startDate,endDate)=>
{
    return (dispatch,getState,{getFirebase})=>
    {
        const firebase = getFirebase();
        firebase.auth().currentUser.getIdToken().then((token)=>
        {
            dispatch({
                type:LOAD_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
            })
            const url = "/count-subs-report/get-count"
            const formData = new FormData();
            formData.append("Start_Date",startDate)
            formData.append("End_Date",endDate)
            const config = {
                headers:{
                    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'X-Authorization-Firebase': token
                }
            
            }
            post(url,formData,config).then((res)=>
            {
                const countrySubscriptions = res.data;
                console.log(countrySubscriptions);
                dispatch({
                    type:GET_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
                    payload:countrySubscriptions
                })
            }).catch((Error)=>
            {
                dispatch({
                    type:ERROR_COUNT_LOADING_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
                    payload:Error.message
                })
            })
        })
    }
}

export const emptyCountForSubscriptionByCountry =()=> dispatch=>
{
    dispatch({
        type:EMPTY_COUNT_SUBSCRIPTIONS_REPORT_BY_COUNTRY,
        payload:[]
    })    
}
